export default __webpack_public_path__ + "static/1324-32a4a702dd22de7695f7b4962960cfff.gif";